import { G_VideoSearchSortKey, G_VideoViewingType } from "~/lib/graphql";

/** sub pageで固定表示するカテゴリカルーセルのアイテム */
export const fixedCategoryItems = [
  {
    id: "general",
    name: "すべて",
  },
  {
    id: "premium",
    name: "見放題",
    params: {
      viewing_types: G_VideoViewingType.Premium,
    },
  },
  {
    id: "new",
    name: "新着",
    params: {
      sort: G_VideoSearchSortKey.New,
    },
  },
];
